<template>
  <div>
    <v-row class="customer-detail custom-border-to">
      <v-col md="12" sm="12" class="pt-0">
        <v-skeleton-loader
          class="custom-skeleton"
          v-if="pageLoading"
          type="table-tbody"
        >
        </v-skeleton-loader>
        <v-simple-table v-else class="simple-table">
          <template v-slot:default>
            <thead>
              <tr style="background-color: #f3f6f9; color: #24326d">
                <th class="simple-table-th" style="width: 60px !important">
                  <v-checkbox
                    v-model="selectedAll"
                    class="hide-margin py-0 my-0"
                    color="cyan"
                    dense
                    hide-details
                  ></v-checkbox>
                </th>
                <th class="simple-table-th pl-3">Opportunity #</th>
                <th class="simple-table-th pl-3">Title</th>
                <th class="simple-table-th pl-3">Status</th>
                <th class="simple-table-th pl-3">Source</th>
                <th class="simple-table-th pl-3">Contact Person</th>
                <th class="simple-table-th pl-3">Contact Details</th>
                <th class="simple-table-th pl-3">Opportunity</th>
                <th class="simple-table-th pl-3">Subtotal</th>
                <th class="simple-table-th pl-3">Discount</th>
                <th class="simple-table-th pl-3">Total</th>
                <th class="simple-table-th pl-3">Created Time</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(opportunity, index) in rowData"
                :key="index"
                :class="{
                  'custom-border-top': index == 0,
                  'orange_lighten-5': index % 2 == 0,
                }"
              >
                <td @click.stop style="width: 60px !important">
                  <v-checkbox
                    v-model="selectedRows"
                    class="hide-margin"
                    color="cyan"
                    dense
                    hide-details
                    v-bind:value="opportunity.id"
                  ></v-checkbox>
                </td>
                <td
                  link
                  v-on:click="selectOpportunity(opportunity)"
                  class="font-size-14 font-weight-500 text-capitalize"
                >
                  <Barcode :barcode="opportunity.barcode"></Barcode>
                </td>
                <td
                  link
                  v-on:click="selectOpportunity(opportunity)"
                  class="font-size-14 font-weight-500 text-capitalize"
                >
                  {{ opportunity.title }}
                </td>
                <td link class="font-size-14 font-weight-500 text-capitalize">
                  <div>
                    <v-switch
                      true-icon="mdi-checkbox-marked"
                      false-icon="mdi-checkbox-outlined"
                      v-model="opportunity.status"
                      class="mt-0"
                      v-on:click.prevent.stop="activeInactive(opportunity)"
                      color="green"
                      inset
                    >
                    </v-switch>
                  </div>
                </td>
                <td
                  link
                  v-on:click="selectOpportunity(opportunity)"
                  class="font-size-14 font-weight-500 text-capitalize"
                >
                  {{ opportunity.source }}
                </td>

                <td
                  link
                  @click="selectOpportunity(opportunity)"
                  class="font-size-14 font-weight-500"
                >
                  <template v-if="opportunity.contact_person?.full_name">
                    <p class="m-0 custom-nowrap-ellipsis">
                      Name: {{ opportunity.contact_person.full_name }}
                    </p>

                    <p class="m-0 custom-nowrap-ellipsis">
                      Position:
                      <span v-if="opportunity.contact_person.designation">
                        {{ opportunity.contact_person.designation }}
                      </span>
                      <em v-else class="text-muted">no position</em>
                    </p>
                  </template>

                  <em v-else class="text-muted">no name</em>
                </td>

                <td
                  link
                  @click="selectOpportunity(opportunity)"
                  class="font-size-14 font-weight-500"
                >
                  <div class="d-flex align-center">
                    <v-icon small class="me-1">mdi-email</v-icon>
                    <span v-if="opportunity.contact_person?.primary_email">
                      {{ opportunity.contact_person.primary_email }}
                    </span>
                    <em v-else class="text-muted">no email address</em>
                  </div>

                  <div class="d-flex align-center mt-1">
                    <v-icon small class="me-1">mdi-phone</v-icon>
                    <span v-if="opportunity.contact_person?.primary_phone">
                      {{ opportunity.contact_person.primary_phone }}
                    </span>
                    <em v-else class="text-muted">no number</em>
                  </div>
                </td>

                <td
                  link
                  v-on:click="selectOpportunity(opportunity)"
                  class="font-size-14 font-weight-500"
                >
                  <template v-if="opportunity && opportunity.opportunity_text">
                    {{ opportunity.opportunity_text }}
                  </template>
                  <em v-else class="text-muted"> no opportunity</em>
                  <!-- {{ opportunity.opportunity_text }} -->
                </td>

                <td class="font-size-14 font-weight-500 text-lowercase">
                  <div
                    v-if="opportunity.sub_total !== undefined"
                    class="quotation-listing-amount"
                  >
                    <p class="m-0 custom-nowrap-ellipsis">
                      <b>Sub Total: </b>
                      <span class="font-weight-700">{{
                        $accountingJS.formatMoney(opportunity.sub_total)
                      }}</span>
                    </p>
                    <p class="m-0 custom-nowrap-ellipsis">
                      <b>Tax: </b>
                      {{ $accountingJS.formatMoney(opportunity.tax_amount) }}
                    </p>
                  </div>
                  <em v-else class="text-muted"> -</em>
                </td>

                <td class="font-size-14 font-weight-500 text-lowercase">
                  <div
                    v-if="opportunity.discount_amount !== undefined"
                    class="quotation-listing-amount"
                  >
                    <p class="m-0 custom-nowrap-ellipsis">
                      <b>Discount: </b>
                      <span v-if="opportunity.discount_value_type == 2"
                        >({{ formatNumber(opportunity.discount_value) }}%)</span
                      >
                      <span v-else>{{
                        $accountingJS.formatMoney(opportunity.discount_amount)
                      }}</span>
                    </p>
                    <p class="m-0 custom-nowrap-ellipsis">
                      <b>Adjustment: </b>
                      {{ $accountingJS.formatMoney(opportunity.adjustment) }}
                    </p>
                  </div>
                  <em v-else class="text-muted"> -</em>
                </td>

                <td class="font-size-14 font-weight-500 text-lowercase">
                  <div class="font-weight-700">
                    {{ $accountingJS.formatMoney(opportunity.total) }}
                  </div>
                </td>

                <td class="font-size-14 font-weight-500 text-lowercase">
                  <TableActivity
                    v-if="!lodash.isEmpty(opportunity.added_by)"
                    :data="opportunity"
                  >
                    <template v-slot:first_letters>
                      {{ getFirstLetters(opportunity?.added_by?.display_name) }}
                    </template>
                    <template v-slot:display_name>
                      <span class="text-capitalize">{{
                        opportunity.added_by.display_name
                      }}</span>
                    </template>
                    <template v-slot:date_time>
                      <template v-if="getDateCountAll(opportunity.added_at)">
                        {{
                          opportunity.created_at ||
                          dateTimeHumanize(opportunity.added_at)
                        }}
                      </template>
                      <template v-else>
                        {{ formatDateTime(opportunity.added_at) }}
                      </template>
                    </template>
                  </TableActivity>
                  <div v-else class="text-muted">-</div>
                </td>
              </tr>

              <tr v-if="rowData.length === 0">
                <td colspan="9" class="text-center py-4">
                  <img
                    :src="$assetURL('media/error/empty.png')"
                    class="row-not-found-image"
                  />
                  <em class="text-muted">
                    Uhh... There are no file at the moment.</em
                  >
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";
import { PATCH } from "@/core/services/store/request.module";
import Barcode from "@/view/pages/partials/Barcode.vue";
export default {
  name: "opportunities",
  title: "Lead",
  mixins: [CommonMixin],
  components: { TableActivity, Barcode },
  props: {
    lead: {
      type: Object,
      required: true,
      default: function () {
        return {};
      },
    },
    pageLoading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      rowData: [],
      selectedRows: [],
    };
  },

  watch: {
    selectedRows(param) {
      this.$emit("selectedRows", param);
    },
    lead: {
      deep: true,
      immediate: true,
      handler() {
        this.assignData();
      },
    },
  },
  methods: {
    /**
     * Emit the opportunity id so parent can open edit page.
     * Accepts either opportunity object or id.
     */
    selectOpportunity(param) {
      const id = param && param.id ? param.id : param;
      const lead = this.lead.id;
      this.$emit("selectOpportunity", id, lead);
    },

    assignData() {
      const _this = this;
      if (_this.lodash.isEmpty(_this.lead.opportunities) === false) {
        _this.rowData = _this.lead.opportunities;
      }
    },
    activeInactive(opportunity) {
      console.log("activeInactive called", opportunity.status);
      const _this = this;
      if (opportunity.status == false) {
        opportunity.status = 0;
      } else {
        opportunity.status = 1;
      }
      _this.$store
        .dispatch(PATCH, {
          url: `single-opportunity/${opportunity.status}/${opportunity.id}`,
          data: {
            id: opportunity.id,
            status: opportunity.status,
          },
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
  },
  mounted() {
    const _this = this;
    _this.assignData();
    _this.$root.$on("clearSelection", () => {
      _this.selectedRows = [];
    });
  },
  beforeDestroy() {
    /*this.$root.$off("clearSelection");*/
  },
  computed: {
    selectedAll: {
      set(param) {
        this.selectedRows = [];
        if (param && this.rowData.length) {
          for (let i = this.rowData.length - 1; i >= 0; i--) {
            this.selectedRows.push(this.rowData[i].id);
          }
        }
      },
      get() {
        let totalItems = this.rowData.length;
        return totalItems > 0 ? this.selectedRows.length === totalItems : false;
      },
    },
  },
};
</script>
